var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsThumbnail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 152,
    viewBox: "0 0 208 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1C3.68629 1 1 3.68629 1 7V145C1 148.314 3.68629 151 7 151H201C204.314 151 207 148.314 207 145V7C207 3.68629 204.314 1 201 1H7Z",
    fill: "#F3F3F3",
    stroke: "#CDCDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35H81V60H61V35Z",
    fill: "#E1E1E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82 35H102V60H82V35Z",
    fill: "#D1D1D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103 35H123V60H103V35Z",
    fill: "#E3E3E3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124 35H144V60H124V35Z",
    fill: "#D1D1D1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145 35H165V60H145V35Z",
    fill: "#E9E9E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M166 35H186V60H166V35Z",
    fill: "#E1E1E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61H81V86H61V61Z",
    fill: "#E1E1E1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82 61H102V86H82V61Z",
    fill: "#D1D1D1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103 61H123V86H103V61Z",
    fill: "#D1D1D1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M124 61H144V86H124V61Z",
    fill: "#D1D1D1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M145 61H165V86H145V61Z",
    fill: "#E3E3E3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M166 61H186V86H166V61Z",
    fill: "#E9E9E9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61 87H81V112H61V87Z",
    fill: "#D1D1D1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82 87H102V112H82V87Z",
    fill: "#D1D1D1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M103 87H123V112H103V87Z",
    fill: "#D1D1D1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M124 87H144V112H124V87Z",
    fill: "#E1E1E1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M145 87H165V112H145V87Z",
    fill: "#D1D1D1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M166 87H186V112H166V87Z",
    fill: "#E9E9E9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61 113H81V138H61V113Z",
    fill: "#E1E1E1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M82 113H102V138H82V113Z",
    fill: "#D1D1D1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M103 113H123V138H103V113Z",
    fill: "#E3E3E3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M124 113H144V138H124V113Z",
    fill: "#D1D1D1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M145 113H165V138H145V113Z",
    fill: "#E9E9E9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M166 113H186V138H166V113Z",
    fill: "#E1E1E1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71 31C75.9706 31 80 26.9706 80 22C80 17.0294 75.9706 13 71 13C66.0294 13 62 17.0294 62 22C62 26.9706 66.0294 31 71 31Z",
    fill: "#A6A8AB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.8002 25.102C73.7587 25.102 73.7172 25.0606 73.6758 25.0606V25.0606C73.0533 24.8116 72.182 24.3137 72.182 23.6083C72.182 22.5294 73.4268 22.3635 73.5928 20.1643C73.7173 18.3801 72.7629 17.0938 70.9787 17.0938C69.1944 17.0938 68.2401 18.3801 68.3646 20.1643C68.5305 22.405 69.7753 22.5709 69.7753 23.6083C69.7753 24.3137 68.904 24.8116 68.2816 25.0606V25.0606C68.2401 25.0606 68.1986 25.102 68.1571 25.102C67.8251 25.268 67.5762 25.6415 67.5762 26.0564C67.5762 26.6373 68.0326 27.0937 68.6135 27.0937H70.9787H73.3438C73.9247 27.0937 74.3811 26.6373 74.3811 26.0564C74.4226 25.6415 74.1737 25.268 73.8002 25.102V25.102Z",
    fill: "#BBBDBF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92 31C96.9706 31 101 26.9706 101 22C101 17.0294 96.9706 13 92 13C87.0294 13 83 17.0294 83 22C83 26.9706 87.0294 31 92 31Z",
    fill: "#A6A8AB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.8002 25.102C94.7587 25.102 94.7172 25.0606 94.6758 25.0606V25.0606C94.0533 24.8116 93.182 24.3137 93.182 23.6083C93.182 22.5294 94.4268 22.3635 94.5928 20.1643C94.7173 18.3801 93.7629 17.0938 91.9787 17.0938C90.1944 17.0938 89.2401 18.3801 89.3646 20.1643C89.5305 22.405 90.7753 22.5709 90.7753 23.6083C90.7753 24.3137 89.904 24.8116 89.2816 25.0606V25.0606C89.2401 25.0606 89.1986 25.102 89.1571 25.102C88.8251 25.268 88.5762 25.6415 88.5762 26.0564C88.5762 26.6373 89.0326 27.0937 89.6135 27.0937H91.9787H94.3438C94.9247 27.0937 95.3811 26.6373 95.3811 26.0564C95.4226 25.6415 95.1737 25.268 94.8002 25.102V25.102Z",
    fill: "#BBBDBF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113 31C117.971 31 122 26.9706 122 22C122 17.0294 117.971 13 113 13C108.029 13 104 17.0294 104 22C104 26.9706 108.029 31 113 31Z",
    fill: "#A6A8AB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.8 25.102C115.759 25.102 115.717 25.0606 115.676 25.0606V25.0606C115.053 24.8116 114.182 24.3137 114.182 23.6083C114.182 22.5294 115.427 22.3635 115.593 20.1643C115.717 18.3801 114.763 17.0938 112.979 17.0938C111.194 17.0938 110.24 18.3801 110.365 20.1643C110.531 22.405 111.775 22.5709 111.775 23.6083C111.775 24.3137 110.904 24.8116 110.282 25.0606V25.0606C110.24 25.0606 110.199 25.102 110.157 25.102C109.825 25.268 109.576 25.6415 109.576 26.0564C109.576 26.6373 110.033 27.0937 110.614 27.0937H112.979H115.344C115.925 27.0937 116.381 26.6373 116.381 26.0564C116.423 25.6415 116.174 25.268 115.8 25.102V25.102Z",
    fill: "#BBBDBF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134 31C138.971 31 143 26.9706 143 22C143 17.0294 138.971 13 134 13C129.029 13 125 17.0294 125 22C125 26.9706 129.029 31 134 31Z",
    fill: "#A6A8AB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.8 25.102C136.759 25.102 136.717 25.0606 136.676 25.0606V25.0606C136.053 24.8116 135.182 24.3137 135.182 23.6083C135.182 22.5294 136.427 22.3635 136.593 20.1643C136.717 18.3801 135.763 17.0938 133.979 17.0938C132.194 17.0938 131.24 18.3801 131.365 20.1643C131.531 22.405 132.775 22.5709 132.775 23.6083C132.775 24.3137 131.904 24.8116 131.282 25.0606V25.0606C131.24 25.0606 131.199 25.102 131.157 25.102C130.825 25.268 130.576 25.6415 130.576 26.0564C130.576 26.6373 131.033 27.0937 131.614 27.0937H133.979H136.344C136.925 27.0937 137.381 26.6373 137.381 26.0564C137.423 25.6415 137.174 25.268 136.8 25.102V25.102Z",
    fill: "#BBBDBF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155 31C159.971 31 164 26.9706 164 22C164 17.0294 159.971 13 155 13C150.029 13 146 17.0294 146 22C146 26.9706 150.029 31 155 31Z",
    fill: "#A6A8AB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.8 25.102C157.759 25.102 157.717 25.0606 157.676 25.0606V25.0606C157.053 24.8116 156.182 24.3137 156.182 23.6083C156.182 22.5294 157.427 22.3635 157.593 20.1643C157.717 18.3801 156.763 17.0938 154.979 17.0938C153.194 17.0938 152.24 18.3801 152.365 20.1643C152.531 22.405 153.775 22.5709 153.775 23.6083C153.775 24.3137 152.904 24.8116 152.282 25.0606V25.0606C152.24 25.0606 152.199 25.102 152.157 25.102C151.825 25.268 151.576 25.6415 151.576 26.0564C151.576 26.6373 152.033 27.0937 152.614 27.0937H154.979H157.344C157.925 27.0937 158.381 26.6373 158.381 26.0564C158.423 25.6415 158.174 25.268 157.8 25.102V25.102Z",
    fill: "#BBBDBF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176 31C180.971 31 185 26.9706 185 22C185 17.0294 180.971 13 176 13C171.029 13 167 17.0294 167 22C167 26.9706 171.029 31 176 31Z",
    fill: "#A6A8AB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.8 25.102C178.759 25.102 178.717 25.0606 178.676 25.0606V25.0606C178.053 24.8116 177.182 24.3137 177.182 23.6083C177.182 22.5294 178.427 22.3635 178.593 20.1643C178.717 18.3801 177.763 17.0938 175.979 17.0938C174.194 17.0938 173.24 18.3801 173.365 20.1643C173.531 22.405 174.775 22.5709 174.775 23.6083C174.775 24.3137 173.904 24.8116 173.282 25.0606V25.0606C173.24 25.0606 173.199 25.102 173.157 25.102C172.825 25.268 172.576 25.6415 172.576 26.0564C172.576 26.6373 173.033 27.0937 173.614 27.0937H175.979H178.344C178.925 27.0937 179.381 26.6373 179.381 26.0564C179.423 25.6415 179.174 25.268 178.8 25.102V25.102Z",
    fill: "#BBBDBF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 42C21.8954 42 21 42.8954 21 44V50C21 51.1046 21.8954 52 23 52H49C50.1046 52 51 51.1046 51 50V44C51 42.8954 50.1046 42 49 42H23Z",
    fill: "#DFE0E1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 68C21.8954 68 21 68.8954 21 70V76C21 77.1046 21.8954 78 23 78H49C50.1046 78 51 77.1046 51 76V70C51 68.8954 50.1046 68 49 68H23Z",
    fill: "#DFE0E1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 94C21.8954 94 21 94.8954 21 96V102C21 103.105 21.8954 104 23 104H49C50.1046 104 51 103.105 51 102V96C51 94.8954 50.1046 94 49 94H23Z",
    fill: "#DFE0E1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 120C21.8954 120 21 120.895 21 122V128C21 129.105 21.8954 130 23 130H49C50.1046 130 51 129.105 51 128V122C51 120.895 50.1046 120 49 120H23Z",
    fill: "#DFE0E1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsThumbnail);
export default __webpack_public_path__ + "static/media/skills-thumbnail.ffe158686b5a00043194fa26b9eb3a80.svg";
export { ForwardRef as ReactComponent };